import { render, staticRenderFns } from "./AtendimentoTriagemVisualizar.vue?vue&type=template&id=24f2e6eb&"
import script from "./AtendimentoTriagemVisualizar.vue?vue&type=script&lang=js&"
export * from "./AtendimentoTriagemVisualizar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports